import cn from "classnames"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { ArticleOutline, MinusLarge, PlusLarge } from "@/skylticons"

export interface HelpArticle {
  id?: string | null
  title?: string | null
  content?: string | null
}

interface HelpArticleProps {
  article: HelpArticle
  updateArticle: (article: HelpArticle) => void
}

interface HelpArticlesProps {
  articles: HelpArticle[]
  header: string
  updateArticle: (article: HelpArticle) => void
  klass?: string
}

const ArticleItem: React.FC<HelpArticleProps> = ({ article, updateArticle }) => {
  return (
    <div className="article">
      <ArticleOutline />
      <p className="paragraph-sm mb-0" onClick={() => updateArticle(article)}>
        {article.title}
      </p>
    </div>
  )
}

const HelpArticles: React.FC<HelpArticlesProps> = ({ articles, updateArticle, klass, header }) => {
  const { t } = useTranslation()
  const [showMore, setShowMore] = useState(false)
  const firstBatch = articles.slice(0, 5)
  const secondBatch = articles.slice(5, articles.length)

  return (
    <div className={cn(`card articles ${klass}`)}>
      <p className="header bold">{header}</p>
      {firstBatch.map(article => {
        return <ArticleItem article={article} updateArticle={updateArticle} key={article.title} />
      })}
      {showMore &&
        secondBatch.map(article => {
          return <ArticleItem article={article} updateArticle={updateArticle} key={article.title} />
        })}

      {secondBatch.length > 0 && (
        <a onClick={() => setShowMore(showMore => !showMore)} className="showmore text-sm">
          {showMore ? (
            <>
              <MinusLarge />
              <span>{t("help_center.less_articles")}</span>
            </>
          ) : (
            <>
              <PlusLarge />
              <span>{t("help_center.more_articles", { count: secondBatch.length })}</span>
            </>
          )}
        </a>
      )}
    </div>
  )
}

export default HelpArticles
